import React, { useEffect, useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Header from '../../../Layout/Header';
import feedback from '../../../../assets/img/notify.jpg';
import Footer from '../../../Layout/Footer';
import { CompleteBuyer, getCompleteBuyer, getCompletedBuyer, getOfferBuyer, getOfferSeller, taskReviewBuyer } from '../../../../Redux/Task/action';
import moment from 'moment';
import { IMAGE_URL } from '../../../../api';
import { Rating } from 'react-simple-star-rating';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { viewUserProfile } from '../../../../Redux/User/action';


const MytaskAssignedBuyer = () => {

    const [assign, setAssign] = useState([]);
    const { state } = useLocation();
    const navigate = useNavigate();
    const [tasks, setTasks] = useState([])
    const [user, setUser] = useState({});

    useEffect(() => {
        getOfferSeller(state?.data?.task_details ? state?.data?.task_details : state?.data?.id)((response) => {
            if (response && response.status) {
                setTasks(response?.data?.data)
            }
        });
        viewUserProfile()((response) => {
            if (response && response.status) {
                setUser(response?.data?.data[0])
            }
        });
    }, []);

    const onCompleteBuyer = () => {
        var task_details = state?.data?.id;
        CompleteBuyer({ task_details })((response) => {
            if (response && response.status) {
                getCompletedBuyer()
                // getOfferBuyer(state?.data?.id)((response) => {
                //     if (response && response.status) {
                //         setTasks(response?.data?.data)
                //     }
                // });
            }
            navigate("/mytaskbuyer")
        });
    }
    const getCompletedBuyer = () => {
        getCompleteBuyer()((response) => {
            if (response && response.status) {
                setAssign(response?.data)
            }
        });
    }

    const validationSchema = Yup.object().shape({
        // rating: Yup.string()
        //     .required('Required'),
        // comment: Yup.string()
        //     .required('Required'),
    });
    const formik = useFormik({
        initialValues: {
            rating: "",
            comment: "",
        },
        validationSchema,
        onSubmit: (values) => {
            const task_details = state?.data?.id
            // formData.append("cancel_reason", values.cancel_reason);
            taskReviewBuyer(rating, values?.comment, task_details)((response) => {
                if (response && response.status) {

                    CompleteBuyer({ task_details })((response) => {
                        if (response && response.status) {
                            getCompletedBuyer()
                        }
                    });
                    navigate("/mytaskbuyer")
                }
                else {

                    formik.setErrors({
                        comment: response?.response?.data?.data?.errors?.comment
                    })
                }

            });
        },
    });
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [rating, setRating] = useState(0)
    // Catch Rating value
    const handleRating = (rate: number) => {
        setRating(rate)
        // other logic
    }

    const handleClickUserTask = () => {
        navigate('/chat/', { state: { collection: tasks?.assigned_to?.email + state?.data?.id + user?.user?.email + state?.data?.id, reciever: tasks?.assigned_to, task_detail: state?.data?.id, task_detail_id: tasks?.id } })
    }
    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>My Task </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Task Details</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="mytask-details">
                <div className="container">
                    <div className="row task-details-main">
                        <div className='col-lg-6'>
                            <div className='border-right-task'>
                                <div className='task-details-flex'>
                                    <h5>{state?.data?.title}</h5>
                                    <React.Fragment>
                                        {tasks?.bid_rate ?
                                            <React.Fragment>
                                                <div className='callchatrate'>
                                                    <p>Bid rate: <i class="bi bi-currency-rupee"></i>{parseFloat(tasks?.bid_rate).toFixed(1)}</p>
                                                </div>
                                            </React.Fragment>
                                            :
                                            <React.Fragment>
                                                <div className='callchatrate'>
                                                    <p>Chat rate: <i class="bi bi-currency-rupee"></i>{parseFloat(tasks?.chat_rate).toFixed(1)}</p>
                                                    <p>Call rate: <i class="bi bi-currency-rupee"></i>{parseFloat(tasks?.call_rate).toFixed(1)} / {state?.data?.assigned_data && state?.data?.assigned_data[0]?.time_field == 1 ? 'hour' : state?.data?.assigned_data && state?.data?.assigned_data[0]?.time_field == 2 ? "min" : tasks?.time_field == 1 ? "hour" : tasks?.time_field == 2 && "min"}</p>
                                                </div>
                                            </React.Fragment>
                                        }
                                    </React.Fragment>


                                </div>
                                <h6>Assigned on: {moment(state?.data?.date_choice).format('ll')}</h6>
                                <div className='service-desc'>
                                    <h5>Service Description</h5>
                                    <p>{state?.data?.description}</p>
                                </div>
                                <div className='chat_dots' onClick={() => handleClickUserTask()}>
                                    <p>Click here to chat with {tasks?.assigned_to?.full_name}</p><i class="bi bi-chat-dots"></i>
                                </div>
                            </div>

                        </div>
                        <div className='col-lg-6'>
                            <div className='offers'>
                                <div className='task-details-flex'>
                                    <h5>Seller info:</h5>
                                </div>

                                {/* {tasks?.map((task, index) =>
                                    <div className='offers-link' onClick={() => navigate('/mytaskassignhistorybuyer', { state: { data: task } })}>
                                        <div className='col-lg-8'>
                                            <div className="member d-flex align-items-center">
                                                <div className="pic"><img src={IMAGE_URL + task?.image[0]?.image} className="img-fluid" alt="" /></div>
                                                <div className="member-info">
                                                    <React.Fragment>
                                                        <h4>{task?.user?.username}</h4>
                                                        <span className="badge badge-light-warning">{parseFloat(task?.review[0]?.rating).toFixed(1)} <i class="bi bi-star-fill"></i></span>
                                                    </React.Fragment>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                )} */}
                                <div className='offers-link' onClick={() => navigate('/mytaskassignhistorybuyer', { state: { data: tasks } })}>
                                    <div className='col-lg-8'>
                                        <div className="member d-flex align-items-center">
                                            <div className="pic"><img src={IMAGE_URL + tasks?.image?.image} className="img-fluid" alt="" style={{ width: "80px" }} /></div>
                                            <div className="member-info">
                                                <React.Fragment>
                                                    <h4>{tasks?.assigned_to?.full_name}</h4>
                                                    {tasks?.avg_rating == "" && tasks?.total_rating == "" ?
                                                        <></>
                                                        :
                                                        <span className="badge badge-light-warning">{parseFloat(tasks?.avg_rating).toFixed(1)} <i class="bi bi-star-fill"></i> ( {tasks?.total_rating} )</span>
                                                    }
                                                    <p>{tasks?.offer_details?.about_yourself}</p>
                                                </React.Fragment>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                                {/* <div className='ms-5 text-center'>
                                    <Button className='offers-assignbtn' variant="primary" onClick={() => navigate('/chat/', { state: { data: tasks } })}>Call</Button>
                                </div> */}
                                {/* <div className='ms-5 text-center'>
                                    <Button className='offers-assignbtn' variant="primary" onClick={handleShow}>Complete Task</Button>
                                </div> */}
                                <Modal show={show} onHide={handleClose}>
                                    <Modal.Header closeButton>

                                    </Modal.Header>
                                    <Modal.Body>
                                        <Form onSubmit={formik.handleSubmit}>
                                            <h6 style={{ fontSize: "16px", fontWeight: "600" }}>Rate the seller</h6>
                                            <Form.Group className="mb-3 d-grid" controlId="exampleForm.ControlTextarea1">
                                                <Form.Label>Tap a star to set your rating</Form.Label>
                                                <Rating
                                                    onClick={handleRating}
                                                    // onPointerEnter={onPointerEnter}
                                                    // onPointerLeave={onPointerLeave}
                                                    // onPointerMove={onPointerMove}
                                                    transition
                                                /* Available Props */
                                                />
                                            </Form.Group>
                                            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                                <Form.Label>Enter comments:</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    name='comment'
                                                    rows={3}
                                                    onChange={formik.handleChange}
                                                    isValid={formik.touched.comment && !formik.errors.comment}
                                                    isInvalid={!!formik.errors.comment}
                                                    value={formik.values?.comment}
                                                />
                                            </Form.Group>

                                            <div className='completed-task-btn text-center'>
                                                <Button variant="primary" className='not-now-btn btn btn-primary' onClick={() => onCompleteBuyer(state?.data?.id)}>
                                                    Not Now
                                                </Button>
                                                <Button type="submit" variant="primary" className='rate-now-btn btn btn-primary'>
                                                    Rate Now
                                                </Button>
                                            </div>

                                        </Form>
                                    </Modal.Body>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <Footer />
        </React.Fragment >
    )
}

export default MytaskAssignedBuyer;